import React, { useContext } from 'react'
import AppContext from './AppContext'

import CurrencyFormat from 'react-currency-format'

const LineItem = ({ lineItem, currency }) => {
  const myContext = useContext(AppContext)

  if (lineItem.itemName === '') return null
  return (
    <div className="flex flex-row justify-between mt-4 font-mono">
      <div className="w-1/3">{lineItem.itemName}</div>
      <div className="w-1/6">{lineItem.qty}</div>
      <div className="w-1/6 text-right">{lineItem.cost}</div>
      <div className="w-1/6 text-right">
        <CurrencyFormat
          value={lineItem.cost * lineItem.qty}
          displayType={'text'}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          prefix={currency || myContext.currency}
        />
      </div>
    </div>
  )
}

export default LineItem
